/** Read a required environment variable — no hardcoded URL fallbacks in source. */

export const requireEnv = (name) => {
  const value = process.env[name];
  if (value === undefined || value === null || !String(value).trim()) {
    throw new Error(
      `Missing required environment variable "${name}". ` +
        "Set it in the project .env file."
    );
  }
  return String(value).trim();
};

export const envOrigin = (name) => requireEnv(name).replace(/\/$/, "");
